import { useEffect, useRef } from "react"

import type { ContactRef } from "../types/compose.types.ts"

type Listener = (contact: ContactRef) => void

const listeners = new Set<Listener>()

/**
 * Says a contact's consent was just recorded. One person can stand behind
 * several contacts (a lead speaks for its customer), so listeners re-read
 * what they show rather than patching one contact's entry.
 */
export const announceConsentChange = (contact: ContactRef) =>
  listeners.forEach((listener) => listener(contact))

export const onConsentChange = (listener: Listener) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Runs `listener` after every recorded consent change while mounted. */
export const useConsentChanges = (listener: Listener) => {
  const latest = useRef(listener)
  latest.current = listener
  useEffect(() => onConsentChange((contact) => latest.current(contact)), [])
}
